module.exports = __webpack_public_path__ + "img/16.b5430f28.svg";